<div class="container">
  <div class="row">
    <div class="col-8">
      <h1 class="page-title">{{ headerTitle | globalTranslate }}</h1>
    </div>
  </div>
  <nh-alert type="danger" [isOpen]="showErr2">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "ERROR_MSG_2" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>

  <nh-alert type="danger" [isOpen]="isAlertMessage">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ alertMessage | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  <div class="card mb-4 bg-custom-register">
    <h2 class="section-header">{{ sectionTitle | globalTranslate }}</h2>
    <hr />

    @if (passwordLinkStatus == 'update') {
    <section>
      <div class="col-md-12">
        <p>{{ "PASSWORD_GUIDELINES_TITLE" | globalTranslate }}</p>
        <form [formGroup]="resetPassword">
          <div class="row">
            <div class="col-12 col-md-6">
              <nh-field
                [isRow]="true"
                label="{{ 'PASSWORD' | globalTranslate }}"
                class="label-section"
              >
                <div class="password-eye">
                  <input
                    id="rp_password"
                    [type]="fieldTextType ? 'text' : 'password'"
                    class="form-control"
                    formControlName="password"
                    placeholder="{{ 'PASSWORD' | globalTranslate }}"
                    (input)="validatePassword($event)"
                    (blur)="checkPassword()"
                    required
                  />
                  <span
                    (click)="toggleFieldTextType('password')"
                    class="eye-icon"
                    ><img
                      alt=""
                      src="assets/images/Icons/eye-outline-password.svg"
                  /></span>
                </div>
              </nh-field>
              <nh-field
                man
                [isRow]="true"
                label="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                class="label-section"
              >
                <div class="password-eye">
                  <input
                    id="rp_confirmPassword"
                    [type]="fieldConfirmPassTextType ? 'text' : 'password'"
                    class="form-control"
                    formControlName="confirmPassword"
                    placeholder="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                    (keyup)="comparePassword($event)"
                    (change)="getErrorMessage()"
                  />
                  <span
                    (click)="toggleFieldTextType('confirmPassword')"
                    class="eye-icon"
                    ><img
                      alt=""
                      src="assets/images/Icons/eye-outline-password.svg"
                  /></span>
                </div>
              </nh-field>
            </div>
            <div class="col-12 col-md-6">
              <div class="password-guide">
                <div class="password-header">
                  <span>{{ "PWD_GUIDE" | globalTranslate }}</span>
                  <hr />
                </div>
                <ul>
                  @if (passwordRuleLen) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden">{{
                          "PASSWORD_REQ_MET" | globalTranslate
                        }}</span>
                        {{ "PG_1" | globalTranslate }}
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleLen) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_1_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_1" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleUpp) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_2_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_2" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleUpp) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_2_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_2" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleLow) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_3_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_3" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleLow) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_3_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_3" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleNum) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_4_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_4" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleNum) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_4_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_4" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (passwordRuleSpl) {
                  <li class="password-rules-valid">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                          {{ "PG_5_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_5" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  } @if (!passwordRuleSpl) {
                  <li class="password-rules">
                    <div class="row password-guide-style">
                      <img
                        class="col px-0"
                        src="../../../assets/images/not met icon_PWGuidelines.svg"
                        alt=""
                        aria-hidden="true"
                      />
                      <div>
                        <span class="visually-hidden"
                          >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                          {{ "PG_5_ADA" | globalTranslate }}</span
                        >
                        <span aria-hidden="true">{{
                          "PG_5" | globalTranslate
                        }}</span>
                      </div>
                    </div>
                  </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </form>
      </div>
      <br />
      <br />
    </section>
    } @if (passwordLinkStatus == 'expired') {
    <section>
      <p>{{ "PASSWORD_LINK_EXP_BODY_TEXT" | globalTranslate }}</p>
      <div class="hover-red">
        <a class="btn btn-link hover-red" [routerLink]="['/signin']">
          <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
          <nh-exit-svg></nh-exit-svg>
        </a>
      </div>
    </section>
    } @if (passwordLinkStatus == 'success') {
    <section>
      <p>{{ "PWD_UPDATED" | globalTranslate }}</p>
      <div class="hover-red">
        <a class="btn btn-link hover-red" [routerLink]="['/signin']">
          <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
          <nh-exit-svg></nh-exit-svg>
        </a>
      </div>
    </section>
    }
  </div>
  @if (passwordLinkStatus == 'update') {
  <div class="row py-4">
    <button
      (click)="updatePassword()"
      [disabled]="!isFormValid()"
      class="btn btn-primary col-md-2"
    >
      {{ "NEXT_BUTTON" | globalTranslate }}
    </button>
  </div>
  }
</div>